import { ENDPOINTS } from './endpoints';
import { bindLocaleIntoHeaders } from '../utils/resolve-locale';
import { fetchData } from './network';

export function getPaginatedBlogPosts(index, categoryId) {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.getBlogPosts.path}`);
  bindLocaleIntoHeaders(url);
  url.searchParams.append('populate', '*');
  url.searchParams.append('sort[0]', 'date:desc');
  url.searchParams.append('pagination[page]', index);
  url.searchParams.append('pagination[pageSize]', 9);

  if (categoryId) {
    url.searchParams.append('filters[categories][id][$eq]', categoryId);
  }

  return fetchData(url, {
    method: ENDPOINTS.getBlogPosts.method
  }).then((response) => response);
}

export function getBlogCategories() {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.getBlogCategories.path}`);
  bindLocaleIntoHeaders(url);
  url.searchParams.append('sort[0]', 'name:asc');

  return fetchData(url, {
    method: ENDPOINTS.getBlogCategories.method
  }).then((response) => response);
}
